import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { TbCube3dSphere } from "react-icons/tb";
import { BsRobot } from "react-icons/bs";
import { RiAdvertisementLine } from "react-icons/ri";
import img1 from "../../../../assets/img/Services/AI&ML/2150247206.jpg"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Image & Video Synthesis
            </h1>
            <p className="text-lg text-gray-600">
            Create AI-generated visuals for design, advertising, and simulations.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BsRobot className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">AI-Driven Visual Design</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Generate unique and tailored visuals for web design, branding, and marketing materials using AI tools.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <RiAdvertisementLine className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Enhanced Advertising Content</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Create compelling AI-generated images and videos for targeted advertising campaigns, improving engagement and conversion rates.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <TbCube3dSphere className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Simulations and Virtual Environments</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Use AI to synthesize realistic visuals for simulations, virtual reality, and 3D environments, enhancing user experience and training applications.
              </p>
            </div>

           
          </div>
        </div>

      
      </div>
    </div>
  )
}